import React, { Component } from 'react';
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import LoginForm from './LoginForm';
import $ from "jquery";
class LoginApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $('#menu_login').addClass('hide_im');
}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <Spinner/>
          <TopMenu title="Login"/>
          <LoginForm/>
          <Footer />
        </div>
    );
  }
}

export default LoginApp;
